<template>
  <section id="description">
    <div class="row">
      <div class="col-md-8">
        <div class="card custom-card">
          <div class="col-md-12">
            <div class="candidate d-sm-block" style="border-radius: 8px 8px 0 0; padding-left: 0">
              <div class="d-flex align-items-center">
                <Avatar :photo="selectedAvatar" @new="reGetProfile" />
                <span v-if="!isInGlobalEditMode" class="candidate-name">
                  <b>{{ getManagerProfile.employer_name }}</b>
                  <span v-show="tab === 0" class="candidate-edit mt-n1 ml-3">
                    <router-link to v-show="!isInGlobalEditMode">
                      <svgHelper
                        @click.native="changeGlobalEditMode"
                        class="candidate-edit-icon"
                        name="edit"
                      ></svgHelper>
                    </router-link>
                  </span>
                </span>
                <div class="d-flex flex-grow-1" v-else>
                  <span class="candidate-name flex-grow-1 mr-2 my-auto">
                    <input
                      v-if="getManagerProfile.can_change_name"
                      type="text"
                      class="form-control"
                      id="employer_name"
                      :placeholder="getManagerProfile.employer_name"
                      v-model="selectedName"
                    />
                    <input
                      v-else
                      type="text"
                      class="form-control"
                      id="employer_name"
                      :placeholder="getManagerProfile.employer_name"
                      disabled
                      title="You can't change employer name while there are jobs that are currently published."
                    />
                  </span>
                  <div class="form-buttons text-right ml-auto">
                    <button @click="updateEmployer" class="btn btn-primary ml-auto">Save</button>
                    <button @click="onCancelUpdateForm" class="btn btn-danger ml-2">Cancel</button>
                  </div>
                </div>
              </div>
            </div>

            <nav class="job-controls-tabs">
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a
                  @click="tab = 0"
                  class="nav-item nav-link active"
                  id="nav-primary-tab"
                  data-toggle="tab"
                  href="#nav-primary"
                  role="tab"
                  aria-controls="nav-primary"
                  aria-selected="true"
                  >DETAILS</a
                >
                <a
                  @click="tab = 1"
                  class="nav-item nav-link"
                  id="nav-templates-tab"
                  data-toggle="tab"
                  href="#nav-templates"
                  role="tab"
                  aria-controls="nav-templates"
                  aria-selected="false"
                  >TEMPLATES</a
                >
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div
                class="tab-pane fade show active"
                id="nav-primary"
                role="tabpanel"
                aria-labelledby="nav-primary-tab"
              >
                <form @submit.prevent="updateEmployer" ref="globalUpdateForm">
                  <!-- Editable info global -->
                  <ul class="list-group list-group-flush employer-details">
                    <div class="row">
                      <li class="list-group-item col-md-6">
                        <div
                          v-if="!editIconState.orgoFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.orgo = true"
                          @mouseleave="editFields.orgo = false"
                          class="d-flex"
                        >
                          <span>
                            <b>Registration number</b>
                          </span>

                          <div style="position: relative">
                            <div
                              v-if="getManagerProfile.registration_number === null"
                              class="edit-btn"
                            >
                              <router-link v-if="editFields.orgo" to class="mr-1">
                                <i
                                  @click="showEditForm($event)"
                                  id="orgo"
                                  class="fas fa-pen edit-icon"
                                ></i>
                              </router-link>
                            </div>
                            {{ getManagerProfile.registration_number }}
                          </div>
                        </div>

                        <span class="d-flex" v-else>
                          <span class="mr-0">
                            <b>Registration number</b>
                          </span>

                          <input
                            :disabled="getManagerProfile.registration_number"
                            id="orgo-number"
                            v-model="selectedOrgo"
                            type="text"
                            class="form-control mr-1"
                          />
                          <button
                            type="submit"
                            v-show="!isInGlobalEditMode"
                            class="btn btn-outline btn-sm border mr-1"
                          >
                            <i class="fas fa-check"></i>
                          </button>
                          <CandidateEditFieldCancelBtn
                            v-show="!isInGlobalEditMode"
                            @clicked="editIconState.orgoFormShow = false"
                          >
                            <i class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </li>

                      <li class="list-group-item col-md-6">
                        <div
                          v-if="!editIconState.vatFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.vat = true"
                          @mouseleave="editFields.vat = false"
                          class="d-flex"
                        >
                          <span>
                            <b>EU VAT number</b>
                          </span>

                          <div style="position: relative">
                            <div class="edit-btn">
                              <router-link v-if="editFields.vat" to class="mr-1">
                                <i
                                  @click="showEditForm($event)"
                                  id="vat"
                                  class="fas fa-pen edit-icon"
                                ></i>
                              </router-link>
                            </div>
                            {{ getManagerProfile.eu_vat_number }}
                          </div>
                        </div>

                        <span class="d-flex" v-else>
                          <span class="mr-0">
                            <b>EU VAT number</b>
                          </span>

                          <input
                            id="vat"
                            v-model="selectedVat"
                            type="text"
                            class="form-control mr-1"
                          />
                          <button
                            type="submit"
                            v-show="!isInGlobalEditMode"
                            class="btn btn-outline btn-sm border mr-1"
                          >
                            <i class="fas fa-check"></i>
                          </button>
                          <CandidateEditFieldCancelBtn
                            v-show="!isInGlobalEditMode"
                            @clicked="editIconState.vatFormShow = false"
                          >
                            <i class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </li>

                      <li class="list-group-item col-md-6">
                        <div
                          v-if="!editIconState.firstNameFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.firstName = true"
                          @mouseleave="editFields.firstName = false"
                          class="d-flex"
                        >
                          <span>
                            <b>First name</b>
                          </span>
                          <div style="position: relative">
                            <div class="edit-btn">
                              <router-link v-if="editFields.firstName" to class="mr-1">
                                <i
                                  @click="showEditForm($event)"
                                  id="first-name"
                                  class="fas fa-pen edit-icon"
                                ></i>
                              </router-link>
                            </div>
                            {{ getManagerProfile.first_name }}
                          </div>
                        </div>

                        <span class="d-flex" v-else>
                          <span class="mr-0">
                            <b>First name</b>
                          </span>

                          <input
                            style="margin-right: 12px"
                            type="text"
                            class="form-control"
                            id="first_name"
                            placeholder="First Name"
                            v-model="selectedFirstName"
                          />

                          <button
                            type="submit"
                            v-show="!isInGlobalEditMode"
                            class="btn btn-outline btn-sm border mr-1"
                          >
                            <i class="fas fa-check"></i>
                          </button>

                          <CandidateEditFieldCancelBtn
                            style="margin-right: 12px"
                            v-show="!isInGlobalEditMode"
                            @clicked="editIconState.firstNameFormShow = false"
                          >
                            <i class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </li>
                      <li class="list-group-item col-md-6 d-none d-sm-block">
                        <div
                          v-if="!editIconState.streetAddressFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.streetAddress = true"
                          @mouseleave="editFields.streetAddress = false"
                          class="d-flex"
                        >
                          <span>
                            <b>Street address</b>
                          </span>

                          <div style="position: relative" v-if="getManagerProfile.address">
                            <div class="edit-btn">
                              <router-link v-if="editFields.streetAddress" to class="mr-1">
                                <i
                                  @click="showEditForm($event)"
                                  id="street-address"
                                  class="fas fa-pen edit-icon"
                                ></i>
                              </router-link>
                            </div>

                            {{
                              getManagerProfile.address.hasOwnProperty('address')
                                ? getManagerProfile.address.address
                                : ''
                            }}
                          </div>
                        </div>

                        <span class="d-flex" v-else>
                          <span class="mr-0">
                            <b>Street address</b>
                          </span>

                          <input
                            type="text"
                            class="form-control"
                            id="street-address"
                            placeholder="Street Address"
                            v-model="selectedStreet"
                          />

                          <button
                            type="submit"
                            v-show="!isInGlobalEditMode"
                            class="btn btn-outline btn-sm border mr-1"
                          >
                            <i class="fas fa-check"></i>
                          </button>

                          <CandidateEditFieldCancelBtn
                            v-show="!isInGlobalEditMode"
                            @clicked="editIconState.streetAddressFormShow = false"
                          >
                            <i class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </li>
                      <li class="list-group-item col-md-6">
                        <div
                          v-if="!editIconState.lastNameFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.lastName = true"
                          @mouseleave="editFields.lastName = false"
                          class="d-flex"
                        >
                          <span>
                            <b>Last name</b>
                          </span>

                          <div style="position: relative">
                            <div class="edit-btn">
                              <router-link v-if="editFields.lastName" to class="mr-1">
                                <i
                                  @click="showEditForm($event)"
                                  id="last-name"
                                  class="fas fa-pen edit-icon"
                                ></i>
                              </router-link>
                            </div>
                            {{ getManagerProfile.last_name }}
                          </div>
                        </div>

                        <span class="d-flex" v-else>
                          <span class="mr-0">
                            <b>Last name</b>
                          </span>

                          <input
                            style="margin-right: 12px"
                            type="text"
                            class="form-control"
                            id="last_name"
                            placeholder="First Name"
                            v-model="selectedLastName"
                          />

                          <button
                            type="submit"
                            v-show="!isInGlobalEditMode"
                            class="btn btn-outline btn-sm border mr-1"
                          >
                            <i class="fas fa-check"></i>
                          </button>

                          <CandidateEditFieldCancelBtn
                            style="margin-right: 12px"
                            v-show="!isInGlobalEditMode"
                            @clicked="editIconState.lastNameFormShow = false"
                          >
                            <i class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </li>
                      <li class="list-group-item col-md-6">
                        <div
                          v-if="!editIconState.postalCodeFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.postalCode = true"
                          @mouseleave="editFields.postalCode = false"
                          class="d-flex"
                        >
                          <span>
                            <b>Postal code</b>
                          </span>

                          <div style="position: relative" v-if="getManagerProfile.address">
                            <div class="edit-btn">
                              <router-link v-if="editFields.postalCode" to class="mr-1">
                                <i
                                  @click="showEditForm($event)"
                                  id="postal-code"
                                  class="fas fa-pen edit-icon"
                                ></i>
                              </router-link>
                            </div>
                            {{ getManagerProfile.address.postal_code }}
                          </div>
                        </div>

                        <span class="d-flex" v-else>
                          <span class="mr-0">
                            <b>Postal code</b>
                          </span>

                          <input
                            type="text"
                            class="form-control"
                            id="postal-code"
                            placeholder="Postal Code"
                            v-model="selectedPostalCode"
                            autocomplete
                          />

                          <button
                            type="submit"
                            v-show="!isInGlobalEditMode"
                            class="btn btn-outline btn-sm border mr-1"
                          >
                            <i class="fas fa-check"></i>
                          </button>

                          <CandidateEditFieldCancelBtn
                            v-show="!isInGlobalEditMode"
                            @clicked="editIconState.postalCodeFormShow = false"
                          >
                            <i class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </li>
                      <li class="list-group-item col-md-6 d-none d-sm-block">
                        <div
                          v-if="!editIconState.titleFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.title = true"
                          @mouseleave="editFields.title = false"
                          class="d-flex"
                        >
                          <span>
                            <b>Title</b>
                          </span>

                          <div style="position: relative; height: 18px">
                            <div class="edit-btn">
                              <router-link v-if="editFields.title" to class="mr-1">
                                <i
                                  @click="showEditForm($event)"
                                  id="title"
                                  class="fas fa-pen edit-icon"
                                ></i>
                              </router-link>
                            </div>
                            {{ getManagerProfile.title }}
                          </div>
                        </div>

                        <span class="d-flex" v-else>
                          <span class="mr-0">
                            <b>Title</b>
                          </span>

                          <input
                            style="margin-right: 12px"
                            type="text"
                            class="form-control"
                            id="title"
                            v-model="selectedTitle"
                          />

                          <button
                            type="submit"
                            v-show="!isInGlobalEditMode"
                            class="btn btn-outline btn-sm border mr-1"
                          >
                            <i class="fas fa-check"></i>
                          </button>

                          <CandidateEditFieldCancelBtn
                            style="margin-right: 12px"
                            v-show="!isInGlobalEditMode"
                            @clicked="editIconState.titleFormShow = false"
                          >
                            <i class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </li>
                      <li class="list-group-item col-md-6">
                        <div
                          v-if="!editIconState.cityFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.city = true"
                          @mouseleave="editFields.city = false"
                          class="d-flex"
                        >
                          <span>
                            <b>Location</b>
                          </span>

                          <div style="position: relative">
                            <div class="edit-btn">
                              <router-link v-if="editFields.city" to>
                                <i
                                  @click="showEditForm($event)"
                                  id="city"
                                  class="fas fa-pen edit-icon"
                                ></i>
                              </router-link>
                            </div>
                            <div
                              v-if="
                                getManagerProfile &&
                                  getManagerProfile.city &&
                                  getManagerProfile.country
                              "
                            >
                              {{ getManagerProfile.city.name }},
                              {{ getManagerProfile.country.name }}
                            </div>
                          </div>
                        </div>

                        <span class="d-flex new-location" v-else>
                          <span class="mr-0">
                            <b>Location</b>
                          </span>
                          <div class="location-container">
                            <v-select
                              class="country-select mr-1"
                              v-model="selectedCountry"
                              @input="
                                fetchCitiesByCountryId($event);
                                clearCity();
                              "
                              label="name"
                              placeholder="Country"
                              :options="getAllCountries"
                              :reduce="country => country"
                              :clearable="false"
                            >
                              <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching && search.length >= 3">
                                  No results found for <em>{{ search }}</em
                                  >.
                                </template>
                                <div style="opacity: 0.5" v-else>
                                  Please type at least 3 characters
                                </div>
                              </template>
                            </v-select>
                            <v-select
                              class="city-select"
                              v-model="selectedCity"
                              @input="setCityModel($event)"
                              label="name"
                              :options="getCitiesListByCountry"
                              :reduce="city => city"
                              :clearable="true"
                            >
                              <template v-slot:no-options>
                                <div style="opacity: 0.5">Please select a country first</div>
                              </template>
                            </v-select>
                          </div>

                          <button
                            v-show="!isInGlobalEditMode"
                            type="submit"
                            class="btn btn-outline btn-sm border mr-1"
                          >
                            <i class="fas fa-check"></i>
                          </button>
                          <CandidateEditFieldCancelBtn
                            v-show="!isInGlobalEditMode"
                            @clicked="editIconState.cityFormShow = false"
                          >
                            <i class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </li>
                      <li class="list-group-item col-md-6" style="padding-right: 15px !important">
                        <div
                          v-if="!editIconState.emailFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.email = true"
                          @mouseleave="editFields.email = false"
                          class="d-flex"
                        >
                          <span>
                            <b>Email</b>
                          </span>

                          <div class="text-truncate" style="position: relative">
                            <div class="edit-btn"></div>
                            <a
                              v-if="getManagerProfile.email"
                              :href="`mailto:${getManagerProfile.email}`"
                              class="mr-3"
                              target="_top"
                              >{{ getManagerProfile.email }}</a
                            >
                          </div>
                        </div>

                        <span class="d-flex" v-else>
                          <span class="mr-0">
                            <b>Email</b>
                          </span>

                          <input
                            style="margin-right: 12px"
                            type="text"
                            class="form-control"
                            id="email"
                            v-model="selectedEmail"
                            disabled
                          />

                          <button
                            type="submit"
                            v-show="!isInGlobalEditMode"
                            class="btn btn-outline btn-sm border mr-1"
                          >
                            <i class="fas fa-check"></i>
                          </button>

                          <CandidateEditFieldCancelBtn
                            v-show="!isInGlobalEditMode"
                            @clicked="editIconState.emailFormShow = false"
                          >
                            <i class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </li>

                      <li class="list-group-item col-md-6 d-none d-sm-block">
                        <div
                          v-if="!editIconState.invoiceEmailFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.invoiceEmail = true"
                          @mouseleave="editFields.invoiceEmail = false"
                          class="d-flex"
                        >
                          <span>
                            <b>Invoicing email</b>
                          </span>

                          <div style="position: relative; height: 18px">
                            <div class="edit-btn">
                              <router-link v-if="editFields.invoiceEmail" to class="mr-1">
                                <i
                                  @click="showEditForm($event)"
                                  id="invoice"
                                  class="fas fa-pen edit-icon"
                                ></i>
                              </router-link>
                            </div>
                            <div class="text-truncate" style="max-width: 260px;">
                              <a
                                v-if="getManagerProfile.invoice_email"
                                :href="`mailto:${getManagerProfile.invoice_email}`"
                                class="mr-3"
                                target="_top"
                                >{{ getManagerProfile.invoice_email }}</a
                              >
                            </div>
                          </div>
                        </div>

                        <span class="d-flex" v-else>
                          <span class="mr-0">
                            <b>Invoicing email</b>
                          </span>

                          <input
                            style="margin-right: 12px"
                            type="text"
                            class="form-control"
                            id="invoice"
                            v-model="selectedInvoice"
                          />

                          <button
                            type="submit"
                            v-show="!isInGlobalEditMode"
                            class="btn btn-outline btn-sm border mr-1"
                          >
                            <i class="fas fa-check"></i>
                          </button>

                          <CandidateEditFieldCancelBtn
                            style="margin-right: 12px"
                            v-show="!isInGlobalEditMode"
                            @clicked="editIconState.invoiceEmailFormShow = false"
                          >
                            <i class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </li>

                      <li class="list-group-item col-md-6">
                        <div
                          v-if="!editIconState.websiteFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.website = true"
                          @mouseleave="editFields.website = false"
                          class="d-flex"
                        >
                          <span>
                            <b>Website</b>
                          </span>

                          <div style="position: relative">
                            <div class="edit-btn">
                              <router-link v-if="editFields.website" to class="mr-1">
                                <i
                                  @click="showEditForm($event)"
                                  id="website"
                                  class="fas fa-pen edit-icon"
                                ></i>
                              </router-link>
                            </div>
                            <a rel="nofollow" target="_blank" :href="getManagerProfile.website">{{
                              getManagerProfile.website
                            }}</a>
                          </div>
                        </div>

                        <span class="d-flex" v-else>
                          <span class="mr-0">
                            <b>Website</b>
                          </span>

                          <input
                            style="margin-right: 12px"
                            type="text"
                            class="form-control"
                            id="website"
                            placeholder="Website"
                            v-model="selectedWebsite"
                          />

                          <button
                            type="submit"
                            v-show="!isInGlobalEditMode"
                            class="btn btn-outline btn-sm border mr-1"
                          >
                            <i class="fas fa-check"></i>
                          </button>

                          <CandidateEditFieldCancelBtn
                            v-show="!isInGlobalEditMode"
                            @clicked="editIconState.websiteFormShow = false"
                          >
                            <i class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </li>
                      <li class="list-group-item col-md-6" style="padding-right: 15px !important">
                        <div
                          v-if="!editIconState.phoneFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.phone = true"
                          @mouseleave="editFields.phone = false"
                          class="d-flex"
                        >
                          <span>
                            <b>Phone</b>
                          </span>

                          <div style="position: relative">
                            <div class="edit-btn">
                              <router-link v-if="editFields.phone" to class="mr-1">
                                <i
                                  @click="showEditForm($event)"
                                  id="phone"
                                  class="fas fa-pen edit-icon"
                                ></i>
                              </router-link>
                            </div>
                            {{ getManagerProfile.phone }}
                          </div>
                        </div>

                        <span class="d-flex" v-else>
                          <span class="mr-0">
                            <b>Phone</b>
                          </span>
                          <div class="new-phone">
                            <v-select
                              @input="addCountryCode(countryCode)"
                              style="font-size: 14px; height: 42px"
                              v-model="countryCode"
                              :options="
                                [...getAllCountries].map(item => `${item.phone_code} ${item.name}`)
                              "
                              :clearable="false"
                            >
                              <template v-slot:option="option">
                                {{ option.label }}
                              </template>
                            </v-select>
                            <input
                              class="form-control"
                              id="phone"
                              v-model="selectedPhone"
                              type="tel"
                              pattern="\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}"
                            />

                            <button
                              v-show="!isInGlobalEditMode"
                              type="submit"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.phoneFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </div>
                        </span>
                      </li>

                      <!-- <li class="list-group-item col-md-6">
                        <div
                          v-if="!editIconState.notificationsFormShow && !isInGlobalEditMode"
                          @mouseover="editFields.notifications = true"
                          @mouseleave="editFields.notifications = false"
                          class="d-flex"
                        >
                          <span>
                            <b>Notifications</b>
                          </span>

                          <div style="position: relative">
                            <div class="edit-btn">
                              <router-link v-if="editFields.notifications" to class="mr-1">
                                <i
                                  @click="showEditForm($event)"
                                  id="notifications"
                                  class="fas fa-pen edit-icon"
                                ></i>
                              </router-link>
                            </div>
                            {{ getManagerProfile.email_notifications ? 'Yes' : 'No' }}
                          </div>
                        </div>

                        <span class="d-flex" v-else>
                          <span class="mr-0">
                            <b>Notifications</b>
                          </span>

                          <div class="custom-control custom-checkbox">
                            <input
                              id="notification"
                              class="mr-2 custom-control-input"
                              type="checkbox"
                              aria-label
                              @change="isNotificationEnabled = !isNotificationEnabled"
                            />
                            <label class="custom-control-label" for="notification"> </label>
                          </div>

                          <button
                            type="submit"
                            v-show="!isInGlobalEditMode"
                            class="btn btn-outline btn-sm border mr-1"
                          >
                            <i class="fas fa-check"></i>
                          </button>

                          <CandidateEditFieldCancelBtn
                            v-show="!isInGlobalEditMode"
                            @clicked="editIconState.notificationsFormShow = false"
                          >
                            <i class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </li> -->

                      <li class="list-group-item col-md-6">
                        <div class="d-flex">
                          <span class="mr-3">Created date</span>
                          <span>{{
                            getManagerProfile.created_at
                              | formatDate({
                                format: getManagerUserProfile.format_date,
                                timezone: getManagerUserProfile.timezone,
                                hasHourAndMinutes: false,
                              })
                          }}</span>
                        </div>
                      </li>
                      <li class="list-group-item col-md-6">
                        <div class="d-flex">
                          <span class="mr-3">Updated</span>
                          <span>{{
                            getManagerProfile.updated_at
                              | formatDate({
                                format: getManagerUserProfile.format_date,
                                timezone: getManagerUserProfile.timezone,
                                hasHourAndMinutes: false,
                              })
                          }}</span>
                        </div>
                      </li>
                    </div>
                  </ul>

                  <!-- Global edit mode -->
                  <!-- <section v-show="isInGlobalEditMode">
                      <ul class="list-group list-group-flush employer-details mt-5">
                        <div class="row">
                          <li class="list-group-item col-md-6">
                            <div class="d-flex align-items-center">
                              <span>Created by</span>
                              <input
                                type="text"
                                class="form-control"
                                id="created_by"
                                :value="getManagerProfile.created_by"
                                disabled
                              />
                            </div>
                          </li>

                          <li class="list-group-item col-md-6">
                            <div class="d-flex align-items-center">
                              <span>Created date</span>

                              <input
                                type="text"
                                class="form-control"
                                id="created_date"
                                :value="getManagerProfile.created_at | formatDate('YY-MM-DD')"
                                disabled
                              />
                            </div>
                          </li>
                          <li class="list-group-item col-md-6">
                            <div class="d-flex align-items-center">
                              <span>Date format</span>
                              <input
                                style="margin-right: 12px"
                                type="text"
                                class="form-control"
                                id="date_format"
                                :value="'20-08-2020'"
                                disabled
                              />
                            </div>
                          </li>
                          <li class="list-group-item col-md-6">
                            <div class="d-flex align-items-center">
                              <span>Career portal</span>
                              <div class="custom-control custom-checkbox">
                                <input
                                  id="career-portal"
                                  class="mr-2 custom-control-input"
                                  type="checkbox"
                                  aria-label
                                  @change="careerPortal = !careerPortal"
                                />
                                <label class="custom-control-label" for="career-portal"> </label>
                              </div>
                            </div>
                          </li>
                        </div>
                      </ul>
                    </section> -->
                  <!-- End Global edit mode -->
                </form>
              </div>

              <div
                class="tab-pane fade temp"
                id="nav-templates"
                role="tabpanel"
                aria-labelledby="nav-templates-tab"
                :key="key"
              >
                <div class="form-group">
                  <div class="d-flex">
                    <label class="label" for="comments-textarea">About Us</label>
                    <div class="buttons ml-auto mb-2">
                      <div v-if="!editAboutUs" class="edit-btn ml-auto">
                        <router-link to class="mr-1">
                          <i
                            @click="onEditAboutUs(selectedDescription)"
                            id="orgo"
                            class="fas fa-pen edit-icon"
                            style="color: #666"
                          ></i>
                        </router-link>
                      </div>
                      <span v-else>
                        <button
                          @click="updateEmployer"
                          type="button"
                          class="btn btn-outline btn-sm border mr-1"
                          style="color: green"
                        >
                          <i class="fas fa-check"></i>
                        </button>

                        <CandidateEditFieldCancelBtn @clicked="onCancelAboutUsEditor">
                          <i style="color: red" class="fas fa-times"></i>
                        </CandidateEditFieldCancelBtn>
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="!editAboutUs && selectedDescription !== null"
                    class="text-editor"
                    v-html="selectedDescription"
                  ></div>
                  <div v-if="!editAboutUs && selectedDescription === null" class="text-editor">
                    <p>
                      Enter a general company description. This text will be inserted in the end of
                      the job ads by default.
                    </p>
                  </div>
                  <div v-show="editAboutUs">
                    <TextEditor v-model="selectedDescription" />
                  </div>
                </div>

                <div class="form-group">
                  <div class="d-flex">
                    <label class="label" for="comments-textarea">Benefits</label>
                    <div class="buttons ml-auto mb-2">
                      <div v-if="!editBenefits" class="edit-btn ml-auto">
                        <router-link to class="mr-1">
                          <i
                            @click="onEditBenefits(benefitsEditor)"
                            id="orgo"
                            class="fas fa-pen edit-icon"
                            style="color: #666"
                          ></i>
                        </router-link>
                      </div>
                      <span v-else>
                        <button
                          @click="updateEmployer"
                          type="button"
                          class="btn btn-outline btn-sm border mr-1"
                          style="color: green"
                        >
                          <i class="fas fa-check"></i>
                        </button>

                        <CandidateEditFieldCancelBtn @clicked="onCancelBenefitsEditor">
                          <i style="color: red" class="fas fa-times"></i>
                        </CandidateEditFieldCancelBtn>
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="!editBenefits && selectedBenefits !== null && selectedBenefits.length > 0"
                    class="text-editor"
                    v-html="selectedBenefits"
                  ></div>
                  <div v-if="!editBenefits && selectedBenefits === null" class="text-editor">
                    <p>
                      Enter a text about what benefits that you offer. This text will be inserted in
                      the job ads when using the job ad text generator.
                    </p>
                  </div>
                  <div v-show="editBenefits">
                    <TextEditor v-model="selectedBenefits" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div id="activities">
          <div class="card custom-card scroll-activities">
            <h6 class="aside-title">Activities</h6>
            <ul class="list-group activities-media">
              <li v-for="activity in activities" style="cursor: pointer" class="list-group-item">
                <div class="activity-container">
                  <popper
                    :append-to-body="true"
                    trigger="hover"
                    :options="{
                      placement: 'top',
                      modifiers: { offset: { offset: '10,20px' } },
                    }"
                  >
                    <div class="popper">
                      {{ activity.creator_name ? activity.creator_name : 'Jobshark' }}
                    </div>
                    <div slot="reference">
                      <img
                        v-if="
                          activity.creator_photo !== null &&
                            activity.creator_photo !== 'null' &&
                            activity.creator_photo !== 'default.png'
                        "
                        src="https://jobshark.eu/img/comstream.svg"
                        alt="activity thumbnail"
                      />
                      <img
                        v-else
                        src="https://jobshark.eu/img/comstream.svg"
                        alt="activity thumbnail"
                      />
                    </div>
                  </popper>
                  <div v-if="activity.type === 'Job'" class="activity-content">
                    <div class="activity-header">
                      <span class="date">
                        {{
                          activity.created_at
                            | formatDate({
                              format: getManagerUserProfile.format_date,
                              timezone: getManagerUserProfile.timezone,
                              hasHourAndMinutes: true,
                            })
                        }}</span
                      >
                    </div>
                    <div class="activity-text">
                      <p>
                        {{ activity.comments ? `${activity.comments}` : '' }}
                      </p>
                    </div>
                  </div>

                  <div v-if="activity.type === 'User'" class="activity-content">
                    <div class="activity-header">
                      <span class="date">
                        {{
                          activity.created_at
                            | formatDate({
                              format: getManagerUserProfile.format_date,
                              timezone: getManagerUserProfile.timezone,
                              hasHourAndMinutes: true,
                            })
                        }}</span
                      >
                    </div>
                    <div class="activity-text">
                      <p>
                        {{ activity.comments ? `${activity.comments}` : '' }}
                      </p>
                    </div>
                  </div>

                  <div
                    v-if="
                      activity.type ===
                        'Account_created' /* &&
            (this.$route.name === 'candidate_id' || this.route.name === 'employer_id') */
                    "
                    class="activity-content"
                  >
                    <div class="activity-header">
                      <span class="title"></span>
                      <span class="date">
                        {{
                          activity.created_at
                            | formatDate({
                              format: getManagerUserProfile.format_date,
                              timezone: getManagerUserProfile.timezone,
                              hasHourAndMinutes: true,
                            })
                        }}</span
                      >
                    </div>
                    <div class="activity-text" style="margin-top:-5px">
                      <p>
                        <span class="bold">Account created</span>
                      </p>
                      <p>{{ activity.comments }}</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <Spinner :isLoading="isLoading" />
            <ErrorList
              class="no-data-message"
              v-show="activities.length === 0"
              name="noActivities"
            />
          </div>
        </div>
      </div>
    </div>
    <!--  <Spinner :isLoading="isLoading" /> -->
  </section>
</template>

<script>
/* import TopNavbar from '@/components/Navigations/TopNavbar';
import ManagerSidebar from '@/components/Navigations/ManagerSidebar'; */
import TextEditor from '@/components/common/TextEditor';
import Avatar from './ManagerProfileAvatar.vue';
import CandidateEditFieldCancelBtn from './common/CandidateEditFieldCancelBtn';
import { errorService } from '../../services/errorService';
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';
import { mapGetters, mapActions } from 'vuex';
import { MESSAGES } from '../../constants';
import ErrorList from '@/components/common/errorsList';
import axios from 'axios';

export default {
  components: {
    /*  ManagerSidebar,
    TopNavbar, */
    CandidateEditFieldCancelBtn,
    TextEditor,
    Avatar,
    ErrorList,
  },
  mixins: [toggleSidebarNav],
  data: () => ({
    tab: 0,
    activities: [],
    editAboutUs: false,
    editBenefits: false,
    selectedAvatar: '',
    selectedName: '',
    selectedOrgo: '',
    selectedVat: '',
    selectedCountry: '',
    selectedCity: '',
    selectedWebsite: '',
    selectedFirstName: '',
    selectedLastName: '',
    selectedTitle: '',
    selectedEmail: '',
    selectedInvoice: '',
    selectedPostalCode: 1000,
    selectedStreet: '',
    countryCode: '',
    selectedCountryCode: '',
    selectedPhone: '',
    selectedDescription: '',
    selectedBenefits: '',
    selectedSecondaryEmail: '',
    isCareerPortalEnabled: false,
    /*    aboutus: '',
    benefits: '', */
    currentAddress: '',
    employerAvatar: '',
    previewAvatar: '',
    employerStatusOptions: [
      { value: 0, label: 'Advertising' },
      { value: 1, label: 'Recruiting' },
      { value: 2, label: 'Internal' },
    ],
    selectedEmployerStatus: 0,
    actualEmployerStatus: 0,
    key: 0,
    careerPortal: false,
    relocation: false,
    showModal: false,
    employerStatusModalShow: false,
    isInGlobalEditMode: false,
    isToggled: false,
    isLoading: false,
    isNotificationEnabled: false,
    employerData: {},
    editFields: {
      employerName: false,
      orgo: false,
      vat: false,
      firstName: false,
      streetAddress: false,
      lastName: false,
      postalCode: false,
      title: false,
      city: false,
      country: false,
      email: false,
      website: false,
      phone: false,
      emailSync: false,
      invoiceEmail: false,
      careerPortal: false,
    },
    editIconState: {
      invoiceEmailFormShow: false,
      employerNameFormShow: false,
      orgoFormShow: false,
      vatFormShow: false,
      firstNameFormShow: false,
      streetAddressFormShow: false,
      lastNameFormShow: false,
      postalCodeFormShow: false,
      titleFormShow: false,
      cityFormShow: false,
      countryFormShow: false,
      emailFormShow: false,
      websiteFormShow: false,
      phoneFormShow: false,
      emailSyncFormShow: false,

      careerPortalFormShow: false,
    },
    componentKey: 0,
    isReadonly: false,
    benefitsEditor: '',
  }),
  methods: {
    ...mapActions(['retrieveCitiesListByCountryId']),
    ...mapActions('managerStoreModule', [
      'retrieveManagerProfile',
      'retrieveManagerUserProfile',
      'updateManagerEmployerById',
    ]),

    getActivities() {
      axios(`${process.env.VUE_APP_API_URL}/manager/activity/foremployer`, {
        method: 'get',
        params: {
          page: 1,
          count: 1000,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(res => (this.activities = res.data.data));
    },
    onCancelBenefitsEditor() {
      this.editBenefits = false;
      this.selectedBenefits = this.getManagerProfile.benefits;
    },
    onCancelAboutUsEditor() {
      this.editAboutUs = false;
      this.selectedDescription = this.getManagerProfile.description;
    },
    onEditAboutUs(aboutus) {
      if (aboutus !== null) {
        this.aboutUsEditor = this.removeHtmlTags(aboutus, 'div');
      }
      this.editAboutUs = true;
    },
    onEditBenefits(benefits) {
      if (benefits !== null) {
        this.benefitsEditor = this.removeHtmlTags(benefits, 'div');
      }
      this.editBenefits = true;
    },
    removeHtmlTags(str, ...args) {
      const removeAllDivTags = /<[/]{0,1}(div)[^><]*>/g;
      // const regex = /(<([^>]+)>)/gi;

      return str
        .replace(removeAllDivTags, '')
        .replace(/<!--.*?-->/g, '')
        .replace(/\r?\n/g, '');
    },
    forceRerender() {
      this.key++;
      this.isReadonly = false;
    },
    addCountryCode(code) {
      this.countryCode = code.replace(/[0-9+]/g, '');
      this.selectedPhone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    clearCity() {
      this.selectedCity = '';
    },
    fetchCitiesByCountryId(country) {
      this.retrieveCitiesListByCountryId({ id: country.id });
    },
    getAddress() {
      this.currentAddress = this.getManagerProfile.address.address;
    },
    updateEmployer() {
      if (!this.selectedCity || !this.selectedCountry) {
        this.$toasted.error(MESSAGES.validationErrorCityAndCountry, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      } else if (this.selectedStreet === '') {
        this.$toasted.error('Street address is required.', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      } else {
        if (this.selectedBenefits === '<p><br></p>') {
          this.selectedBenefits = '';
        }
        if (this.selectedDescription === '<p><br></p>') {
          this.selectedDescription = '';
        }
        this.updateManagerEmployerById({
          js_employer_id: this.$route.params.employer_id,
          name: this.selectedName,
          registration_number: this.selectedOrgo,
          eu_vat_number: this.selectedVat,
          country_id: this.selectedCountry.id,
          city_id: this.selectedCity.id,
          website: this.selectedWebsite,
          first_name: this.selectedFirstName,
          last_name: this.selectedLastName,
          title: this.selectedTitle,
          postal_code: this.selectedPostalCode,
          street: this.selectedStreet,
          phone_number: this.selectedPhone,
          description: this.selectedDescription,
          benefits: this.selectedBenefits,
          email_notifications: false,
          invoice_email: this.selectedInvoice,
        }).then(() => {
          this.isInGlobalEditMode = false;
          this.editAboutUs = false;
          this.editBenefits = false;
          for (const key in this.editIconState) {
            this.editIconState[key] = false;
          }

          this.retrieveManagerProfile().then(() => {
            this.selectedDescription = this.getManagerProfile.description;
            this.selectedBenefits = this.getManagerProfile.benefits;
          });

          this.retrieveManagerUserProfile();

          this.$toasted.success(MESSAGES.saved, {
            theme: 'bubble',
            position: 'bottom-right',
            duration: 5000,
          });
        });

        this.isInGlobalEditMode = false;
      }
    },
    reGetProfile() {
      this.retrieveManagerProfile().then(() => {
        this.selectedAvatar = this.getManagerProfile.photo;
      });
    },
    onCancelUpdateForm() {
      this.isInGlobalEditMode = false;
      this.$refs.globalUpdateForm.reset();
    },
    updateLocalEmployer(e) {
      this.$set(this.employerData, e.target.id, e.target.value);
    },
    changeGlobalEditMode() {
      let extractedNumbers = this.getManagerProfile.phone.match(/^(\+\d+)\s/);
      if (extractedNumbers) {
        let countryCode = extractedNumbers[1]; // Extracted numbers before the space
        let exists = this.getAllCountries.find(country => country.phone_code === countryCode);

        if (exists) {
          this.countryCode = exists.name;
        } else {
          this.countryCode = '';
        }
      }
      this.selectedOrgo = this.getManagerProfile.registration_number;
      this.selectedVat = this.getManagerProfile.eu_vat_number;
      this.selectedFirstName = this.getManagerProfile.first_name;
      this.selectedLastName = this.getManagerProfile.last_name;
      this.selectedSecondaryEmail = this.getManagerProfile.email2;
      this.selectedPhone = this.getManagerProfile.phone;
      this.selectedAddress = this.getManagerProfile.street;
      this.selectedPostalCode = this.getManagerProfile.address.postal_code;
      this.selectedLinkedin = this.getManagerProfile.linkedin;
      this.selectedWebPage = this.getManagerProfile.webpage;
      this.selectedInvoice = this.getManagerProfile.invoice_email;
      this.isInGlobalEditMode = !this.isInGlobalEditMode;
    },
    onChangeEmployerStatus() {
      this.employerStatusModalShow = true;
    },

    onCancelSetEmployerAgreement() {
      this.employerStatusModalShow = false;
      this.selectedEmployerStatus = this.actualEmployerStatus;
    },
    showEditForm(e) {
      if (e.target.id === 'invoice') {
        this.editIconState.invoiceEmailFormShow = !this.editIconState.invoiceEmailFormShow;
      }
      if (e.target.id === 'vat') {
        this.editIconState.vatFormShow = !this.editIconState.vatFormShow;
      }

      if (e.target.id === 'orgo') {
        this.editIconState.orgoFormShow = !this.editIconState.orgoFormShow;
      }

      if (e.target.id === 'first-name') {
        this.editIconState.firstNameFormShow = !this.editIconState.firstNameFormShow;
      }

      if (e.target.id === 'last-name') {
        this.editIconState.lastNameFormShow = !this.editIconState.lastNameFormShow;
      }

      if (e.target.id === 'street-address') {
        this.editIconState.streetAddressFormShow = !this.editIconState.streetAddressFormShow;
      }

      if (e.target.id === 'postal-code') {
        this.editIconState.postalCodeFormShow = !this.editIconState.postalCodeFormShow;
      }

      if (e.target.id === 'title') {
        this.editIconState.titleFormShow = !this.editIconState.titleFormShow;
      }

      if (e.target.id === 'city') {
        this.editIconState.cityFormShow = !this.editIconState.cityFormShow;
      }

      if (e.target.id === 'country') {
        this.editIconState.countryFormShow = !this.editIconState.countryFormShow;
      }

      if (e.target.id === 'email') {
        this.editIconState.emailFormShow = !this.editIconState.emailFormShow;
      }

      if (e.target.id === 'website') {
        this.editIconState.websiteFormShow = !this.editIconState.websiteFormShow;
      }

      if (e.target.id === 'phone') {
        let extractedNumbers = this.getManagerProfile.phone.match(/^(\+\d+)\s/);
        if (extractedNumbers) {
          let countryCode = extractedNumbers[1]; // Extracted numbers before the space
          let exists = this.getAllCountries.find(country => country.phone_code === countryCode);

          if (exists) {
            this.countryCode = exists.name;
          } else {
            this.countryCode = '';
          }
        }
        this.selectedPhone = this.getManagerProfile.phone;

        this.editIconState.phoneFormShow = !this.editIconState.phoneFormShow;
      }

      if (e.target.id === 'email-sync') {
        this.editIconState.emailSyncFormShow = !this.editIconState.emailSyncFormShow;
      }

      /*  if (e.target.id === 'notifications') {
        this.editIconState.notificationsFormShow = !this.editIconState.notificationsFormShow;
      } */

      if (e.target.id === 'career-portal') {
        this.editIconState.careerPortalFormShow = !this.editIconState.careerPortalFormShow;
      }
    },
  },
  computed: {
    ...mapGetters(['getCitiesListByCountry', 'getAllCountries']),
    ...mapGetters('managerStoreModule', ['getManagerProfile', 'getManagerUserProfile']),
  },
  mounted() {
    this.isLoading = true;
    this.getActivities();
    this.retrieveManagerProfile()
      .then(() => {
        this.isLoading = false;
        this.selectedName = this.getManagerProfile.employer_name;
        this.selectedOrgo = this.getManagerProfile.registration_number;
        this.selectedVat = this.getManagerProfile.eu_vat_number;
        this.selectedCountry = this.getManagerProfile.country;
        this.selectedCity = this.getManagerProfile.city;
        this.selectedWebsite = this.getManagerProfile.website;
        this.selectedFirstName = this.getManagerProfile.first_name;
        this.selectedLastName = this.getManagerProfile.last_name;
        this.selectedEmail = this.getManagerProfile.email;
        this.selectedPostalCode = this.getManagerProfile.address.postal_code;
        this.selectedStreet = this.getManagerProfile.address.address;
        this.selectedPhone = this.getManagerProfile.phone;
        this.selectedDescription = this.getManagerProfile.description;
        this.selectedBenefits = this.getManagerProfile.benefits;
        this.selectedTitle = this.getManagerProfile.title;
        this.selectedAvatar = this.getManagerProfile.photo;
        this.selectedInvoice = this.getManagerProfile.invoice_email;
        this.forceRerender();
        this.retrieveCitiesListByCountryId({ id: this.selectedCountry.id });
      })
      .catch(err => {
        this.isLoading = false;

        this.$toasted.error(errorService(err), {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      });
  },
  updated() {
    // this.employerData = this.getManagerProfile;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.list-group-item {
  padding: 20px 8px !important;
}
.activity-container {
  display: flex;
  width: 100%;
  img {
    width: 42px;
    height: 42px;
    max-width: 42px;
    overflow: hidden;
    border-radius: 100%;
    object-fit: cover;
    margin: 5px 12px 0 0;
  }
  .activity-content {
    flex: 1;
    .activity-header {
      display: flex;
      margin-bottom: 5px;
      .title {
        display: block;
        flex: 1;
        margin-right: 8px;
        font-size: 14px;
      }
      .date {
        margin-left: auto;
        font-size: 12px;
      }
    }
    .activity-text {
      font-size: 14px;
      p {
        margin-bottom: 0;
        .bold {
          font-weight: 700;
          span {
            color: #f05a00;
          }
          .pipeline {
            color: #000;
          }
        }
      }
    }
  }
}

b {
  font-weight: 700 !important;
}

.label {
  font-weight: 700;
}

.text-editor {
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 2px;
  padding: 12px;
  margin: 6px 0;
}
#description {
  padding: 0 24px;
}
.card {
  height: 836px;
  margin: 0 0 24px 0;
  padding-bottom: 0px;
  .tab-content {
    margin: 1rem;
  }
}

.tech-icons {
  img {
    width: 30px;
    height: auto;
  }

  .icon-container:not(:last-child) {
    margin-right: 20px;
  }
}

.opted-checkbox {
  margin-right: 1rem;
}

.list-group {
  .list-group-item {
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
    background-color: transparent;
    padding-right: 4px !important;
    .btn {
      background-color: #fff;
      border: 1px solid rgba(60, 60, 60, 0.26) !important;
      width: 24px;
      height: 24px;
      margin-left: 2px;
      font-size: 12px;
      flex-shrink: 0;
      border-radius: 5px;
      padding: 0;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin-top: 2.4px;
      .fa-check {
        color: green;
      }
      .fa-times {
        color: Red;
      }
    }
  }
}

.employer-picture {
  position: relative;
  width: 64px;
  height: 64px;
  margin-right: 12px !important;
  flex-shrink: 0;
  .btn-success {
    margin-right: 10px;
  }
  .overlay {
    cursor: pointer;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.125);
    opacity: 0;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}

.candidate-edit {
  float: right;
  margin-top: 10px;

  &-icon {
    fill: #a3a6b4;
  }

  &-icon:hover {
    fill: #c1c4d4;
  }
}

.candidate-info-form {
  /* margin-left: -2rem; */

  button {
    padding-top: 1px;
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 1px;

    i {
      font-size: 8px;
    }
  }
}

.edit-icon {
  font-size: 1.1rem !important;
}

form {
  input {
    height: 30px;
  }
}

.employer-details {
  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  margin: 0 7px 0 7px;

  .list-group-item {
    border: none !important;
    .d-flex {
      border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
      margin: 3px 0px;
      padding: 12px 0;
      height: 46px;
    }
  }

  li span {
    min-width: 140px !important;
    display: inline-block;
    white-space: nowrap;
    text-align: justify;
    margin-right: 1rem;
  }

  li span:first-child {
    font-weight: 700;
  }

  .edit-btn {
    position: absolute;
    top: 0;
    left: -25px;
    .edit-icon {
      color: #666;
    }
  }
}

.mobile-only {
  display: none !important;
}

.desktop-only {
  display: block;
}

.form-buttons {
  align-self: center;
  display: flex;
  width: 150px;
  flex-wrap: wrap;
  height: 38px;
  i {
    margin-left: auto;
  }
}

@media only screen and (max-width: 1251px) {
  #description {
    padding: 0;
  }
  .card {
    margin-top: 24px !important;
  }
  .employer-aside {
    display: none !important;
  }
}

@media only screen and (max-width: 992px) {
  #description {
    padding: 0;
    .card {
      border-top-left-radius: 18px;
      border-top-right-radius: 18px;
      margin: 24px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
      .tab-content {
        margin: 0;
      }
    }
    .container {
      max-width: 100%;
    }
    .col-md-8 {
      display: block;
      flex: 100%;
      width: 100% !important;
      max-width: 100%;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
  .no-mobile {
    border: none;
  }
  .list-group-item {
    .d-flex {
      margin: 3px 12px !important;
    }
  }
  .temp {
    margin: 1rem;
  }
}

@media only screen and (max-width: 768px) {
  #description {
    padding: 0;
    .card {
      margin: 26px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
  .no-mobile {
    border: none;
  }
  .temp {
    margin: 1rem;
  }
}

@media only screen and (max-width: 576px) {
  #description {
    padding: 0;
    .card {
      margin: 26px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
  .no-mobile {
    border: none;
  }
  .temp {
    margin: 1rem;
  }
}
</style>
